import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import LeadsList from '@/pages/LeadsList';
import AdminLeads from '@/pages/AdminLeads';
import AdminTeam from '@/pages/AdminTeam';
import AdminMonitor from '@/pages/AdminMonitor';
import PipelineBoard from '@/pages/PipelineBoard';
import ImportLeads from '@/pages/ImportLeads';
import Reports from '@/pages/Reports';
import UserGuide from '@/pages/UserGuide';
import Layout from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/leads" element={<LeadsList />} />
                    <Route path="/admin/leads" element={<AdminLeads />} />
                    <Route path="/admin/team" element={<AdminTeam />} />
                    <Route path="/admin/monitor" element={<AdminMonitor />} />
                    <Route path="/pipeline" element={<PipelineBoard />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/import" element={<ImportLeads />} />
                    <Route path="/guide" element={<UserGuide />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;